import { render, staticRenderFns } from "./ClassMenuDetail.vue?vue&type=template&id=44b77b12&scoped=true"
import script from "./ClassMenuDetail.vue?vue&type=script&lang=js"
export * from "./ClassMenuDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassMenuDetail.vue?vue&type=style&index=0&id=44b77b12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b77b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b77b12')) {
      api.createRecord('44b77b12', component.options)
    } else {
      api.reload('44b77b12', component.options)
    }
    module.hot.accept("./ClassMenuDetail.vue?vue&type=template&id=44b77b12&scoped=true", function () {
      api.rerender('44b77b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/ClassMenuDetail.vue"
export default component.exports